import { cls } from "@/utils/util";
import { useEffect, useState } from "react";
import LogoAndSearchBar from "@/component/header/LogoAndSearchBar";
import Tabs from "@/component/header/Tabs";
import WingBannerWrapper from "./WingBannerWrapper";

const SCROLL_THRESHOLD = 60;

const Header = () => {
  const scrolled = useScroll();

  return (
    <header
      className={cls(
        scrolled ? "fixed" : "relative",
        "top-0 left-0 right-0 flex flex-col z-[100] mx-auto gap-[20px]",
      )}
    >
      <WingBannerWrapper scrolled={scrolled} />
      <LogoAndSearchBar scrolled={scrolled} />
      <Tabs scrolled={scrolled} />
    </header>
  );
};

export default Header;

const useScroll = () => {
  const [scrolled, setScrolled] = useState(window.scrollY > SCROLL_THRESHOLD);

  const onPageScroll = () => {
    setScrolled(window.scrollY > SCROLL_THRESHOLD);
  };

  useEffect(() => {
    window.addEventListener("scroll", onPageScroll, false);
    return () => {
      window.removeEventListener("scroll", onPageScroll, false);
    };
  }, []);

  return scrolled;
};
